import { Plugins } from '@leverege/plugin';

/**
 * The ValueSourceFactory maps the valueSourceType to a plugin that contains a 
 * getValues() call. The Plugin addition should look like: 
 * <pre>
 *   molten.addPlugin( 'Molten.GroupingValueSource', { 
 *     type : <groupValueSource>, 
 *     valueSource : <ValueSource>
 *   } )
 * </pre>
 * 
 * ValueSource should be either a class that is newed with the object, or a function
 * that takes the object and returns an object. The new instance/result of function 
 * should have a getValues( objRef, grouping, cxt ) call that returns an array of 
 * Value objects. Values have at minimium { id, value, name } and optionally 
 * { abbreviation, filter , geoLayers }
 */
const ValueSourceFactory = Plugins.createFactory('Molten.GroupingValueSource', {
  pluginKey: 'valueSource'
});
export default ValueSourceFactory;